var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"h-full"},[_c('router-view'),(!_vm.network.isOnline)?_c('div',{staticClass:"error-bar"},[_vm._v(" Your internet connection is disconnected. Please check network. ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }